import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ark-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.scss']
})
export class AlertMessageComponent implements OnInit {

  @Input() label: string;

  constructor() { }

  ngOnInit() {
  }

}
